<template>
  <div class="container">
    <header>{{ this.title }}</header>
    <div class="content">
      <img
        :src="require('@/assets/img/data-inherit/data-inherit.png')"
        alt=""
      />
      <router-link to="/data-inherit-input" @click.native="() => { trapTrackEvent(1) }">
        <button>会員IDを引き継ぐ</button>
      </router-link>

      <router-link to="/walk-through" @click.native="() => { trapTrackEvent(2) }">
        <button class="first">はじめてこのアプリを利用する場合</button>
      </router-link>
    </div>
  </div>
</template>

<script>
import '@/styles/color.css'

import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'

export default {
  name: 'DataInherit',
  data() {
    return {
      title: '会員IDの引き継ぎ'
    }
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    trapTrackEvent(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createDataInheritInput())
          break
        case 2:
          this.trackEvent(FactoryTrack.createWalkThrough())
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  font-family: HiraKakuPro-W6;
  font-size: 15px;
  font-weight: bold;
  color: #333333;
  border-bottom: 1px #dddddd solid;
  background-color: #ffffff;

  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container {
  background-color: var(--background-color);
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .content {
    padding: 0 30px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  img {
    width: 100%;
    margin-bottom: 30px;
  }
}

button {
  width: 100%;
  height: 44px;
  background: var(--accent-color);
  border-radius: 7px;
  border: none;
  font-size: 15px;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 15px;

  &.first {
    background-color: #ffffff;
    color: var(--accent-color);
  }
}
</style>
